import s from "./Documents.module.scss";
import {HeaderSection} from "components/HeaderSection/HeaderSection";
import React, {useEffect, useState} from "react";
import {useDeleteDocumentMutation, useGetDocumentsQuery, useUpdateDocumentsOrderMutation} from "../../redux/apis/documentsApi";
import {Preloader} from "components/Preloader/Preloader";
import {AddDocument} from "./AddDocument/AddDocument";
import {Term} from "utils/term";
import {handleCopyText} from "utils/copyText";
import { ReactComponent as CheckIcon } from "assets/icons/check.svg";
import { ReactComponent as CopyIcon } from "assets/icons/copy.svg";
import { ReactComponent as DeleteIcon } from "assets/icons/delete_icon2.svg";
import {ModalGeneral} from "components/Modals/ModalGeneral";
import questionMark from "assets/images/questionMark.webp";
import {useTranslation} from "react-i18next";
import {useStatusContext} from "components/StatusProvider";
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as MoveIcon } from 'assets/icons/move.svg';
import { Tabs } from "components/Tabs/Tabs";
import { useParams } from "react-router-dom";
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  rectSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const Documents = () => {
    const [type, setType] = useState<string | undefined>(undefined);
    const [isAddDocument, setIsAddDocument] = useState<any>({show: false, document: false});
    const [isCopied, setIsCopied] = useState<any>({done: false, id: null});
    const [deletedId, setDeletedId] = useState<number>();
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const { t } = useTranslation();
    const [deleteDocument] = useDeleteDocumentMutation();
    const { openStatus } = useStatusContext();
    const pathname = useParams()
    const [documents, setDocuments] = useState<any[]>([]);

    const {data, isFetching: isFetchingDocuments, refetch} = useGetDocumentsQuery({type});

    const items = [
        {
            id: 0,
            title: t('Documents'),
            path: "/documents/main"
        },
        {
            id: 1,
            title: t('Guides'),
            path: "/documents/guides"
        }
    ]
    
    const [tab, setTab] = useState(pathname["*"] === "guides" ? items[1]?.id : items[0]?.id)
    const [UpdateOrder] = useUpdateDocumentsOrderMutation()

    const handleDeleteDocument = async (id: number) => {
        const result = await deleteDocument({
            id: id
        })

        if (result?.data?.message === "Document deleted successful") {
            openStatus('success', "status.operationSuccessful");
        } else {
            openStatus('error', "status.error");
        }
    }

    useEffect(()=>{
        if(data){
            setDocuments(data)
        }
    },[data, isFetchingDocuments]);

    useEffect(()=>{
        switch (pathname["*"]) {
            case "main":
                setType("document")
                break;

            case "guides":
                setType("guide")
                break;
        
            default:
                setType("document")
                break;
        }
    },[pathname]);

    useEffect(() => {
        refetch()
    }, []);

    if (isAddDocument?.show) {
        return (
            <AddDocument setIsAddDocument={setIsAddDocument} document={isAddDocument?.document} />
        )
    }

    const handleCopyLink = async (document: any, setIsCopied: any) => {
        const url = process.env.REACT_APP_FRONT_URL;
        console.log("document", document);
        try {
            await navigator.clipboard.writeText(`${url}document/${document?.slug}`);
            setIsCopied({ done: true, id: document?.id });
            setTimeout(() => setIsCopied({done: false, id: null }), 1000);
        } catch (err) {
            console.error("Не вдалося скопіювати текст", err);
        }
    };

    const handleDragEnd = (event: any) => {
        const { active, over } = event;

        if (!over || active.id === over.id) return;

        const old = documents.find(doc => doc.id === active.id);
        const neww = documents.find(doc => doc.id === over.id);

        const oldIndex = documents.indexOf(old);
        const newIndex = documents.indexOf(neww);
        
        const sortedData = arrayMove(documents, oldIndex, newIndex);

        setDocuments(sortedData);
        
        UpdateOrder(sortedData.map((item: any, index: number) => ({
            id: item.id,
            position: index + 1
        })))
    };

    function DocumentItem({document}: any) {
        const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        } = useSortable({ id: document.id });

          const style = {
            transform: CSS.Transform.toString(transform),
            transition,
          };


        return (
            <div className={s.card} ref={setNodeRef} {...attributes}  style={style}>
                <div className={s.card_top}>
                    {
                        (isCopied?.done && isCopied?.id === document.id) ? (
                            <>
                                <span>Success!</span>
                                <CheckIcon className={s.check}/>
                            </>

                        ) : (
                            <>
                                <p onClick={() => handleCopyLink(document, setIsCopied)}>Copy link</p>
                                <CopyIcon className={s.copy} onClick={() => handleCopyLink(document, setIsCopied)}/>
                            </>
                        )
                    }

                    {
                        <DeleteIcon className={s.delete} onClick={() => {
                            setDeletedId(document.id);
                            setShowDeleteModal(true);
                        }}
                        />
                    }
                    {
                        <EditIcon className={s.edit} onClick={() => setIsAddDocument({
                            show: true,
                            document: document
                        })}
                        />
                    }
                </div>

                <div className={s.card_main} {...listeners} >
                    <h3><Term>{document?.title?.document_title}</Term></h3>

                    <p><Term>{document?.body?.document_body}</Term></p>

                    <MoveIcon className={s.edit} onClick={() => setIsAddDocument({
                        show: true,
                        document: document
                    })}/>
                </div>


            </div>
        );
    }

    return (
        <div className={s.wrap_documents}>
            {isFetchingDocuments && <Preloader />}

            <HeaderSection
                title={"Documents"}
                buttonText={"Add documents"}
                onClick={() => setIsAddDocument({show: true})}
            />

            <div className={s.tabs_wrapper}>
                <Tabs
                    items={items}
                    tab={tab}
                    setTab={setTab}
                />
            </div>

            <DndContext
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
            >
                <SortableContext
                    items={documents}
                    strategy={rectSortingStrategy}
                >
                    <div className={s.list}>
                        { documents?.map((document: any, index: number) => (
                            <DocumentItem key={document.id} document={document} />
                        )) }
                    </div>
                </SortableContext>

            </DndContext>


            <ModalGeneral
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal}
                title={t("general.delete")}
                textLeftButton={t("general.cancel")}
                textRightButton={t("general.delete")}
                image={questionMark}
                description={`${t("general.areYouSure")}? ${t("general.itsContents")}`}
                deletedId={deletedId}
                buttonRight={handleDeleteDocument}
            />
        </div>
    )
}